import React from 'react';
import { observer } from 'mobx-react';
import { Popover } from 'antd';
import { If, Then, Else } from 'react-if';
import cn from 'classnames';

import { StyledScaleContainer, StyledTriangle, StyledTargetCircle } from '../styled';
import BarPopover from '../BarPopover/BarPopover';
import { getBar, isValueInTargetRange } from './Scale.utils';

const Scale = observer(
  ({
    scale,
    value,
    isRelativeScale,
    unit,
    $specialStyleKPIBox,
    totalRange,
    trianglePosition,
    targetValue,
    targetPosition,
  }) => {
    const isTargetValueInRange = isValueInTargetRange(scale, value);

    const bars = scale.values.map((_val, i) =>
      getBar(scale, i, isRelativeScale, totalRange, value, targetValue, unit, $specialStyleKPIBox),
    );

    return (
      <StyledScaleContainer $specialStyleKPIBox={$specialStyleKPIBox && value}>
        <If condition={!!value}>
          <Then>
            <StyledTriangle $location={trianglePosition} $specialStyleKPIBox={$specialStyleKPIBox} />
            {targetValue !== undefined && (
              <Popover placement="bottom" content={<BarPopover value={targetValue} unit={unit} />}>
                <StyledTargetCircle
                  $location={targetPosition}
                  data-testid="target-circle"
                  $isTargetValueInRange={isTargetValueInRange}
                />
              </Popover>
            )}
            <div className={cn('bars', $specialStyleKPIBox && 'margin-top')}>{bars}</div>
          </Then>
          <Else>
            <div className="disabled-bars" />
          </Else>
        </If>
      </StyledScaleContainer>
    );
  },
);

export default Scale;
